// update-optional-confirm-dialog.component.ts

import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'ers-update-optional-confirm-dialog',
  standalone: true,
  imports: [
    TranslocoPipe,CommonModule, MatDialogModule],
  templateUrl: './update-optional-confirm-dialog.component.html',
  styleUrls: ['./update-optional-confirm-dialog.component.scss'],
})
export class UpdateOptionalConfirmDialogComponent {
  constructor(public dialogRef: MatDialogRef<UpdateOptionalConfirmDialogComponent>) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
